export type BringgFontIconsId =
  | "alt-route"
  | "analytics"
  | "arrow-down"
  | "arrow-left"
  | "arrow-right"
  | "arrow-up"
  | "arrow"
  | "arrows-up-down"
  | "attachment"
  | "bars-filter"
  | "battery-full"
  | "battery-ver-empty"
  | "battery-ver-half"
  | "battery-ver-quarter"
  | "battery-ver-three-quarters"
  | "bicycle"
  | "block"
  | "break-to"
  | "bringg"
  | "bullseye"
  | "bus"
  | "cafe-solid"
  | "cafe"
  | "calendar"
  | "cancel"
  | "car"
  | "cart"
  | "cashier"
  | "chat-bubble"
  | "checklist"
  | "chevron-left"
  | "chevron-right"
  | "chevron-up"
  | "chevron"
  | "chevrons-end"
  | "chevrons-start"
  | "circle-exclamation"
  | "circle"
  | "clock-light"
  | "clock"
  | "close-circle"
  | "close"
  | "coins"
  | "colorize"
  | "columns"
  | "compass"
  | "completed"
  | "connected-hub"
  | "copy"
  | "credit-card"
  | "csv-file"
  | "design-services"
  | "distance"
  | "dot"
  | "download"
  | "drag"
  | "driver-home"
  | "drivers-returning-to-base"
  | "dropoff"
  | "eco"
  | "expenses"
  | "export"
  | "external-link"
  | "eye-off"
  | "eye"
  | "file-alt"
  | "file-import"
  | "file"
  | "filter-list"
  | "flat-tire"
  | "fork-left-right-back"
  | "forward"
  | "globe"
  | "go-to-link"
  | "graph"
  | "hamburger"
  | "hand-pan-move"
  | "hand-pointing-up"
  | "heart-filled"
  | "heart"
  | "help"
  | "home"
  | "hourglass"
  | "info-filled"
  | "info"
  | "inventory"
  | "keyboard"
  | "layers"
  | "leaf-eco"
  | "library-books"
  | "link"
  | "list"
  | "loader"
  | "local-shipping"
  | "location"
  | "lock"
  | "logout"
  | "man"
  | "map-task"
  | "map"
  | "menu-horizontal"
  | "menu"
  | "message-mail"
  | "minus"
  | "monitor"
  | "my-location"
  | "navigation-up"
  | "navigation"
  | "note-light"
  | "notification"
  | "open-in-new"
  | "package"
  | "pallets"
  | "parking-location"
  | "pause"
  | "pdf-file"
  | "pencil"
  | "phone"
  | "pickup"
  | "play"
  | "plus"
  | "power"
  | "preparation-restaurant"
  | "print"
  | "promped-message"
  | "redo-arrow"
  | "redo"
  | "report"
  | "reschedule"
  | "revenues"
  | "route"
  | "ruler"
  | "save"
  | "scanner"
  | "search"
  | "selected"
  | "settings"
  | "share"
  | "sheet-with-dollar"
  | "show-less"
  | "show-more"
  | "small-circle"
  | "sort-asc"
  | "sort-desc"
  | "star"
  | "sticky-note"
  | "stop-circle"
  | "suffix"
  | "suitcase"
  | "support"
  | "takeout-dining"
  | "task-alt"
  | "team-home"
  | "team-parking"
  | "ticket"
  | "trailer"
  | "trash"
  | "truck"
  | "undo-arrow"
  | "undo"
  | "unuser"
  | "user"
  | "users"
  | "verification-code"
  | "warning"
  | "weight"
  | "wheel"
  | "zoom-in"
  | "zoom-out";

export type BringgFontIconsKey =
  | "AltRoute"
  | "Analytics"
  | "ArrowDown"
  | "ArrowLeft"
  | "ArrowRight"
  | "ArrowUp"
  | "Arrow"
  | "ArrowsUpDown"
  | "Attachment"
  | "BarsFilter"
  | "BatteryFull"
  | "BatteryVerEmpty"
  | "BatteryVerHalf"
  | "BatteryVerQuarter"
  | "BatteryVerThreeQuarters"
  | "Bicycle"
  | "Block"
  | "BreakTo"
  | "Bringg"
  | "Bullseye"
  | "Bus"
  | "CafeSolid"
  | "Cafe"
  | "Calendar"
  | "Cancel"
  | "Car"
  | "Cart"
  | "Cashier"
  | "ChatBubble"
  | "Checklist"
  | "ChevronLeft"
  | "ChevronRight"
  | "ChevronUp"
  | "Chevron"
  | "ChevronsEnd"
  | "ChevronsStart"
  | "CircleExclamation"
  | "Circle"
  | "ClockLight"
  | "Clock"
  | "CloseCircle"
  | "Close"
  | "Coins"
  | "Colorize"
  | "Columns"
  | "Compass"
  | "Completed"
  | "ConnectedHub"
  | "Copy"
  | "CreditCard"
  | "CsvFile"
  | "DesignServices"
  | "Distance"
  | "Dot"
  | "Download"
  | "Drag"
  | "DriverHome"
  | "DriversReturningToBase"
  | "Dropoff"
  | "Eco"
  | "Expenses"
  | "Export"
  | "ExternalLink"
  | "EyeOff"
  | "Eye"
  | "FileAlt"
  | "FileImport"
  | "File"
  | "FilterList"
  | "FlatTire"
  | "ForkLeftRightBack"
  | "Forward"
  | "Globe"
  | "GoToLink"
  | "Graph"
  | "Hamburger"
  | "HandPanMove"
  | "HandPointingUp"
  | "HeartFilled"
  | "Heart"
  | "Help"
  | "Home"
  | "Hourglass"
  | "InfoFilled"
  | "Info"
  | "Inventory"
  | "Keyboard"
  | "Layers"
  | "LeafEco"
  | "LibraryBooks"
  | "Link"
  | "List"
  | "Loader"
  | "LocalShipping"
  | "Location"
  | "Lock"
  | "Logout"
  | "Man"
  | "MapTask"
  | "Map"
  | "MenuHorizontal"
  | "Menu"
  | "MessageMail"
  | "Minus"
  | "Monitor"
  | "MyLocation"
  | "NavigationUp"
  | "Navigation"
  | "NoteLight"
  | "Notification"
  | "OpenInNew"
  | "Package"
  | "Pallets"
  | "ParkingLocation"
  | "Pause"
  | "PdfFile"
  | "Pencil"
  | "Phone"
  | "Pickup"
  | "Play"
  | "Plus"
  | "Power"
  | "PreparationRestaurant"
  | "Print"
  | "PrompedMessage"
  | "RedoArrow"
  | "Redo"
  | "Report"
  | "Reschedule"
  | "Revenues"
  | "Route"
  | "Ruler"
  | "Save"
  | "Scanner"
  | "Search"
  | "Selected"
  | "Settings"
  | "Share"
  | "SheetWithDollar"
  | "ShowLess"
  | "ShowMore"
  | "SmallCircle"
  | "SortAsc"
  | "SortDesc"
  | "Star"
  | "StickyNote"
  | "StopCircle"
  | "Suffix"
  | "Suitcase"
  | "Support"
  | "TakeoutDining"
  | "TaskAlt"
  | "TeamHome"
  | "TeamParking"
  | "Ticket"
  | "Trailer"
  | "Trash"
  | "Truck"
  | "UndoArrow"
  | "Undo"
  | "Unuser"
  | "User"
  | "Users"
  | "VerificationCode"
  | "Warning"
  | "Weight"
  | "Wheel"
  | "ZoomIn"
  | "ZoomOut";

export enum BringgFontIcons {
  AltRoute = "alt-route",
  Analytics = "analytics",
  ArrowDown = "arrow-down",
  ArrowLeft = "arrow-left",
  ArrowRight = "arrow-right",
  ArrowUp = "arrow-up",
  Arrow = "arrow",
  ArrowsUpDown = "arrows-up-down",
  Attachment = "attachment",
  BarsFilter = "bars-filter",
  BatteryFull = "battery-full",
  BatteryVerEmpty = "battery-ver-empty",
  BatteryVerHalf = "battery-ver-half",
  BatteryVerQuarter = "battery-ver-quarter",
  BatteryVerThreeQuarters = "battery-ver-three-quarters",
  Bicycle = "bicycle",
  Block = "block",
  BreakTo = "break-to",
  Bringg = "bringg",
  Bullseye = "bullseye",
  Bus = "bus",
  CafeSolid = "cafe-solid",
  Cafe = "cafe",
  Calendar = "calendar",
  Cancel = "cancel",
  Car = "car",
  Cart = "cart",
  Cashier = "cashier",
  ChatBubble = "chat-bubble",
  Checklist = "checklist",
  ChevronLeft = "chevron-left",
  ChevronRight = "chevron-right",
  ChevronUp = "chevron-up",
  Chevron = "chevron",
  ChevronsEnd = "chevrons-end",
  ChevronsStart = "chevrons-start",
  CircleExclamation = "circle-exclamation",
  Circle = "circle",
  ClockLight = "clock-light",
  Clock = "clock",
  CloseCircle = "close-circle",
  Close = "close",
  Coins = "coins",
  Colorize = "colorize",
  Columns = "columns",
  Compass = "compass",
  Completed = "completed",
  ConnectedHub = "connected-hub",
  Copy = "copy",
  CreditCard = "credit-card",
  CsvFile = "csv-file",
  DesignServices = "design-services",
  Distance = "distance",
  Dot = "dot",
  Download = "download",
  Drag = "drag",
  DriverHome = "driver-home",
  DriversReturningToBase = "drivers-returning-to-base",
  Dropoff = "dropoff",
  Eco = "eco",
  Expenses = "expenses",
  Export = "export",
  ExternalLink = "external-link",
  EyeOff = "eye-off",
  Eye = "eye",
  FileAlt = "file-alt",
  FileImport = "file-import",
  File = "file",
  FilterList = "filter-list",
  FlatTire = "flat-tire",
  ForkLeftRightBack = "fork-left-right-back",
  Forward = "forward",
  Globe = "globe",
  GoToLink = "go-to-link",
  Graph = "graph",
  Hamburger = "hamburger",
  HandPanMove = "hand-pan-move",
  HandPointingUp = "hand-pointing-up",
  HeartFilled = "heart-filled",
  Heart = "heart",
  Help = "help",
  Home = "home",
  Hourglass = "hourglass",
  InfoFilled = "info-filled",
  Info = "info",
  Inventory = "inventory",
  Keyboard = "keyboard",
  Layers = "layers",
  LeafEco = "leaf-eco",
  LibraryBooks = "library-books",
  Link = "link",
  List = "list",
  Loader = "loader",
  LocalShipping = "local-shipping",
  Location = "location",
  Lock = "lock",
  Logout = "logout",
  Man = "man",
  MapTask = "map-task",
  Map = "map",
  MenuHorizontal = "menu-horizontal",
  Menu = "menu",
  MessageMail = "message-mail",
  Minus = "minus",
  Monitor = "monitor",
  MyLocation = "my-location",
  NavigationUp = "navigation-up",
  Navigation = "navigation",
  NoteLight = "note-light",
  Notification = "notification",
  OpenInNew = "open-in-new",
  Package = "package",
  Pallets = "pallets",
  ParkingLocation = "parking-location",
  Pause = "pause",
  PdfFile = "pdf-file",
  Pencil = "pencil",
  Phone = "phone",
  Pickup = "pickup",
  Play = "play",
  Plus = "plus",
  Power = "power",
  PreparationRestaurant = "preparation-restaurant",
  Print = "print",
  PrompedMessage = "promped-message",
  RedoArrow = "redo-arrow",
  Redo = "redo",
  Report = "report",
  Reschedule = "reschedule",
  Revenues = "revenues",
  Route = "route",
  Ruler = "ruler",
  Save = "save",
  Scanner = "scanner",
  Search = "search",
  Selected = "selected",
  Settings = "settings",
  Share = "share",
  SheetWithDollar = "sheet-with-dollar",
  ShowLess = "show-less",
  ShowMore = "show-more",
  SmallCircle = "small-circle",
  SortAsc = "sort-asc",
  SortDesc = "sort-desc",
  Star = "star",
  StickyNote = "sticky-note",
  StopCircle = "stop-circle",
  Suffix = "suffix",
  Suitcase = "suitcase",
  Support = "support",
  TakeoutDining = "takeout-dining",
  TaskAlt = "task-alt",
  TeamHome = "team-home",
  TeamParking = "team-parking",
  Ticket = "ticket",
  Trailer = "trailer",
  Trash = "trash",
  Truck = "truck",
  UndoArrow = "undo-arrow",
  Undo = "undo",
  Unuser = "unuser",
  User = "user",
  Users = "users",
  VerificationCode = "verification-code",
  Warning = "warning",
  Weight = "weight",
  Wheel = "wheel",
  ZoomIn = "zoom-in",
  ZoomOut = "zoom-out",
}

export const BRINGG_FONT_ICONS_CODEPOINTS: { [key in BringgFontIcons]: string } = {
  [BringgFontIcons.AltRoute]: "61697",
  [BringgFontIcons.Analytics]: "61698",
  [BringgFontIcons.ArrowDown]: "61699",
  [BringgFontIcons.ArrowLeft]: "61700",
  [BringgFontIcons.ArrowRight]: "61701",
  [BringgFontIcons.ArrowUp]: "61702",
  [BringgFontIcons.Arrow]: "61703",
  [BringgFontIcons.ArrowsUpDown]: "61704",
  [BringgFontIcons.Attachment]: "61705",
  [BringgFontIcons.BarsFilter]: "61706",
  [BringgFontIcons.BatteryFull]: "61707",
  [BringgFontIcons.BatteryVerEmpty]: "61708",
  [BringgFontIcons.BatteryVerHalf]: "61709",
  [BringgFontIcons.BatteryVerQuarter]: "61710",
  [BringgFontIcons.BatteryVerThreeQuarters]: "61711",
  [BringgFontIcons.Bicycle]: "61712",
  [BringgFontIcons.Block]: "61713",
  [BringgFontIcons.BreakTo]: "61714",
  [BringgFontIcons.Bringg]: "61715",
  [BringgFontIcons.Bullseye]: "61716",
  [BringgFontIcons.Bus]: "61717",
  [BringgFontIcons.CafeSolid]: "61718",
  [BringgFontIcons.Cafe]: "61719",
  [BringgFontIcons.Calendar]: "61720",
  [BringgFontIcons.Cancel]: "61721",
  [BringgFontIcons.Car]: "61722",
  [BringgFontIcons.Cart]: "61723",
  [BringgFontIcons.Cashier]: "61724",
  [BringgFontIcons.ChatBubble]: "61725",
  [BringgFontIcons.Checklist]: "61726",
  [BringgFontIcons.ChevronLeft]: "61727",
  [BringgFontIcons.ChevronRight]: "61728",
  [BringgFontIcons.ChevronUp]: "61729",
  [BringgFontIcons.Chevron]: "61730",
  [BringgFontIcons.ChevronsEnd]: "61731",
  [BringgFontIcons.ChevronsStart]: "61732",
  [BringgFontIcons.CircleExclamation]: "61733",
  [BringgFontIcons.Circle]: "61734",
  [BringgFontIcons.ClockLight]: "61735",
  [BringgFontIcons.Clock]: "61736",
  [BringgFontIcons.CloseCircle]: "61737",
  [BringgFontIcons.Close]: "61738",
  [BringgFontIcons.Coins]: "61739",
  [BringgFontIcons.Colorize]: "61740",
  [BringgFontIcons.Columns]: "61741",
  [BringgFontIcons.Compass]: "61742",
  [BringgFontIcons.Completed]: "61743",
  [BringgFontIcons.ConnectedHub]: "61744",
  [BringgFontIcons.Copy]: "61745",
  [BringgFontIcons.CreditCard]: "61746",
  [BringgFontIcons.CsvFile]: "61747",
  [BringgFontIcons.DesignServices]: "61748",
  [BringgFontIcons.Distance]: "61749",
  [BringgFontIcons.Dot]: "61750",
  [BringgFontIcons.Download]: "61751",
  [BringgFontIcons.Drag]: "61752",
  [BringgFontIcons.DriverHome]: "61753",
  [BringgFontIcons.DriversReturningToBase]: "61754",
  [BringgFontIcons.Dropoff]: "61755",
  [BringgFontIcons.Eco]: "61756",
  [BringgFontIcons.Expenses]: "61757",
  [BringgFontIcons.Export]: "61758",
  [BringgFontIcons.ExternalLink]: "61759",
  [BringgFontIcons.EyeOff]: "61760",
  [BringgFontIcons.Eye]: "61761",
  [BringgFontIcons.FileAlt]: "61762",
  [BringgFontIcons.FileImport]: "61763",
  [BringgFontIcons.File]: "61764",
  [BringgFontIcons.FilterList]: "61765",
  [BringgFontIcons.FlatTire]: "61766",
  [BringgFontIcons.ForkLeftRightBack]: "61767",
  [BringgFontIcons.Forward]: "61768",
  [BringgFontIcons.Globe]: "61769",
  [BringgFontIcons.GoToLink]: "61770",
  [BringgFontIcons.Graph]: "61771",
  [BringgFontIcons.Hamburger]: "61772",
  [BringgFontIcons.HandPanMove]: "61773",
  [BringgFontIcons.HandPointingUp]: "61774",
  [BringgFontIcons.HeartFilled]: "61775",
  [BringgFontIcons.Heart]: "61776",
  [BringgFontIcons.Help]: "61777",
  [BringgFontIcons.Home]: "61778",
  [BringgFontIcons.Hourglass]: "61779",
  [BringgFontIcons.InfoFilled]: "61780",
  [BringgFontIcons.Info]: "61781",
  [BringgFontIcons.Inventory]: "61782",
  [BringgFontIcons.Keyboard]: "61783",
  [BringgFontIcons.Layers]: "61784",
  [BringgFontIcons.LeafEco]: "61785",
  [BringgFontIcons.LibraryBooks]: "61786",
  [BringgFontIcons.Link]: "61787",
  [BringgFontIcons.List]: "61788",
  [BringgFontIcons.Loader]: "61789",
  [BringgFontIcons.LocalShipping]: "61790",
  [BringgFontIcons.Location]: "61791",
  [BringgFontIcons.Lock]: "61792",
  [BringgFontIcons.Logout]: "61793",
  [BringgFontIcons.Man]: "61794",
  [BringgFontIcons.MapTask]: "61795",
  [BringgFontIcons.Map]: "61796",
  [BringgFontIcons.MenuHorizontal]: "61797",
  [BringgFontIcons.Menu]: "61798",
  [BringgFontIcons.MessageMail]: "61799",
  [BringgFontIcons.Minus]: "61800",
  [BringgFontIcons.Monitor]: "61801",
  [BringgFontIcons.MyLocation]: "61802",
  [BringgFontIcons.NavigationUp]: "61803",
  [BringgFontIcons.Navigation]: "61804",
  [BringgFontIcons.NoteLight]: "61805",
  [BringgFontIcons.Notification]: "61806",
  [BringgFontIcons.OpenInNew]: "61807",
  [BringgFontIcons.Package]: "61808",
  [BringgFontIcons.Pallets]: "61809",
  [BringgFontIcons.ParkingLocation]: "61810",
  [BringgFontIcons.Pause]: "61811",
  [BringgFontIcons.PdfFile]: "61812",
  [BringgFontIcons.Pencil]: "61813",
  [BringgFontIcons.Phone]: "61814",
  [BringgFontIcons.Pickup]: "61815",
  [BringgFontIcons.Play]: "61816",
  [BringgFontIcons.Plus]: "61817",
  [BringgFontIcons.Power]: "61818",
  [BringgFontIcons.PreparationRestaurant]: "61819",
  [BringgFontIcons.Print]: "61820",
  [BringgFontIcons.PrompedMessage]: "61821",
  [BringgFontIcons.RedoArrow]: "61822",
  [BringgFontIcons.Redo]: "61823",
  [BringgFontIcons.Report]: "61824",
  [BringgFontIcons.Reschedule]: "61825",
  [BringgFontIcons.Revenues]: "61826",
  [BringgFontIcons.Route]: "61827",
  [BringgFontIcons.Ruler]: "61828",
  [BringgFontIcons.Save]: "61829",
  [BringgFontIcons.Scanner]: "61830",
  [BringgFontIcons.Search]: "61831",
  [BringgFontIcons.Selected]: "61832",
  [BringgFontIcons.Settings]: "61833",
  [BringgFontIcons.Share]: "61834",
  [BringgFontIcons.SheetWithDollar]: "61835",
  [BringgFontIcons.ShowLess]: "61836",
  [BringgFontIcons.ShowMore]: "61837",
  [BringgFontIcons.SmallCircle]: "61838",
  [BringgFontIcons.SortAsc]: "61839",
  [BringgFontIcons.SortDesc]: "61840",
  [BringgFontIcons.Star]: "61841",
  [BringgFontIcons.StickyNote]: "61842",
  [BringgFontIcons.StopCircle]: "61843",
  [BringgFontIcons.Suffix]: "61844",
  [BringgFontIcons.Suitcase]: "61845",
  [BringgFontIcons.Support]: "61846",
  [BringgFontIcons.TakeoutDining]: "61847",
  [BringgFontIcons.TaskAlt]: "61848",
  [BringgFontIcons.TeamHome]: "61849",
  [BringgFontIcons.TeamParking]: "61850",
  [BringgFontIcons.Ticket]: "61851",
  [BringgFontIcons.Trailer]: "61852",
  [BringgFontIcons.Trash]: "61853",
  [BringgFontIcons.Truck]: "61854",
  [BringgFontIcons.UndoArrow]: "61855",
  [BringgFontIcons.Undo]: "61856",
  [BringgFontIcons.Unuser]: "61857",
  [BringgFontIcons.User]: "61858",
  [BringgFontIcons.Users]: "61859",
  [BringgFontIcons.VerificationCode]: "61860",
  [BringgFontIcons.Warning]: "61861",
  [BringgFontIcons.Weight]: "61862",
  [BringgFontIcons.Wheel]: "61863",
  [BringgFontIcons.ZoomIn]: "61864",
  [BringgFontIcons.ZoomOut]: "61865",
};
